import type * as core from '../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.orgStructureSpace',
    'package:data.higherEd.research.awards',
    'resource:data.dimensions.projects',
    'resource:data.dimensions.projects.entities.project',
    'resource:data.dimensions.projects.entities.project.attributes.award',
    'resource:data.dimensions.projects.entities.project.attributes.organization',
    'resource:data.dimensions.projectSpace',
    'resource:data.dimensions.projectSpace.entities.entry',
    'resource:data.dimensions.projectSpace.entities.entry.attributes.space',
    'resource:data.dimensions.projectSpace.entities.entry.attributes.project',
    'resource:data.dimensions.projectPis',
    'resource:data.dimensions.projectPis.entities.entry',
    'resource:data.dimensions.projectPis.entities.entry.attributes.project',
    'resource:data.dimensions.projectPis.entities.entry.attributes.pi',
  ],
  description: 'TODO',
  name: 'Research Data - Projects',
} as const satisfies core.quiver.Package
